function isMobile() {
    return window.matchMedia("(max-width: 1280px)").matches;
}

document.addEventListener('DOMContentLoaded', () => {
    const speakersSections = document.querySelectorAll('.carousel.speakers');

    if (speakersSections.length <= 0) {
        throw new DOMException('Missing speakers carousel section.');
    }

    // Support for multiple carousels with same class
    Array.from(speakersSections).forEach((speakerSection) => {
        let carouselInner = speakerSection.getElementsByClassName('carousel-inner');

        if (carouselInner.length !== 1) {
            throw new DOMException('Invalid number of carousel-inner elements.');
        }

        carouselInner = carouselInner[0];

        const slides = carouselInner.getElementsByClassName('carousel-item');

        if (slides.length <= 0) {
            throw new DOMException('Missing carousel-item elements.');
        }

        Array.from(slides).forEach((slide) => {
            slide.addEventListener('click', () => {
                if (isMobile()) {
                    return;
                }

                Array.from(carouselInner.querySelectorAll('.carousel-item.active')).forEach((activeSlide) => {
                    activeSlide.classList.remove('active');
                });

                slide.classList.add('active');
            });
        });
    });
});
